import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Documents() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/me/documents").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <div className="overline mb-4">Documents from your purchased lots</div>
      {rows.length === 0 ? (
        <div className="border border-dashed border-black/20 p-10 text-center text-zinc-600">
          No documents yet. Documents appear here after your first order.
        </div>
      ) : (
        <div className="border border-black/10 divide-y divide-black/10">
          {rows.map((c) => (
            <div key={c.id} className="p-4 flex items-center justify-between">
              <div>
                <div className="font-display font-semibold">{c.title}</div>
                <div className="text-xs font-mono text-zinc-500 mt-1">Batch {c.batch_number}</div>
              </div>
              <a href={c.document_url} target="_blank" rel="noreferrer" className="btn-outline">View</a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
